import { ContentSolid } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  className: string
}

export const ContentIndicator: React.FC<Props> = ({ className }) => (
  <div className={clsJoin(className, css.content, 'content_indicator')}>
    <ContentSolid className={clsJoin(css.icon, 'content_indicator_icon')} />
  </div>
)
